import type { ISbComponentType } from "storyblok-js-client";

const hasDevices = (
	blok: ISbComponentType<string>,
): blok is ISbComponentType<string> & {
	devices: string[] | string;
} => {
	return "devices" in blok && (typeof blok.devices === "string" || Array.isArray(blok.devices));
};

export const useDeviceControlProps = (blok: ISbComponentType<string>) => {
	if (hasDevices(blok)) {
		if (Array.isArray(blok.devices)) {
			if (blok.devices.length === 1) {
				return {
					"data-control-viewport": blok.devices[0],
				};
			}

			return {
				"data-control-viewport": "all",
			};
		}

		return {
			"data-control-viewport": blok.devices,
		};
	}

	return {};
};
